import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration - Real credentials
const firebaseConfig = {
  apiKey: "AIzaSyB_gXqaA-gQqIaEVOOgS_HicNvkGWZvFMU",
  authDomain: "gst-manage.firebaseapp.com",
  projectId: "gst-manage",
  storageBucket: "gst-manage.firebasestorage.app",
  messagingSenderId: "492854094701",
  appId: "1:492854094701:web:e478fe54bb64ca48418864",
  measurementId: "G-JRERW027PK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
// Bind explicitly to the correct bucket to avoid CORS/mis-bucket issues
export const storage = getStorage(app, 'gs://gst-manage.firebasestorage.app');

export default app;
